export const isCountryLevelPathId = (pathId: string) => {
  const pathArr = pathId.split('/');

  return pathArr.length === 1 && pathId.includes('cnt_');
};
